import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { userApi } from "../api/useApi";
import { PAGINATION } from "../constants/common";

export const useUsers = (params) => {
  const queryKey = ["/users", params];
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey,
    queryFn: async () => await userApi.getAll(params),
  });

  const create = useMutation({
    mutationFn: async (body) => await userApi.create(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const update = useMutation({
    mutationFn: async (body) => await userApi.update(body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const remove = useMutation({
    mutationFn: async (id) => await userApi.remove(id),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  const adminChangePassword = useMutation({
    mutationFn: async ({ id, newPassword }) =>
      await userApi.adminChangePassword(id, { newPassword }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  return {
    data: data?.data || [],
    pagination: data?.pagination || PAGINATION,
    total: data?.pagination.total || 0,
    loading: isLoading,
    error,
    create,
    update,
    remove,
    adminChangePassword,
  };
};
